/* app/js/src/components/common/ag-grid-evrideo/ag-grid-evrideo-header/ag-grid-evrideo-header.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.ag-grid-evrideo-header-container {
  display: flex;
  align-items: center;
  padding: 15px 15px 15px 20px;
  justify-content: space-between;
  border-bottom: rgba(0, 0, 0, 0.1);
}
.selection {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}
.selection pre {
  color: rgb(45, 187, 252);
  cursor: pointer;
}
.selection pre:hover {
  text-decoration: underline;
}
.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.action-buttons > div {
  cursor: pointer;
  display: flex;
  padding: 9px 16px 9px 9px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
}
/*# sourceMappingURL=ag-grid-evrideo-header.component.css.map */
